import { render, staticRenderFns } from "./sw-ftr-hello-sonicwall.vue?vue&type=template&id=1dcb0b82&"
import script from "./sw-ftr-hello-sonicwall.vue?vue&type=script&lang=tsx&"
export * from "./sw-ftr-hello-sonicwall.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports